import { TrashIcon } from "@phosphor-icons/react";
import { Flex, Typography } from "antd";

interface WorkspaceInviteProps {
  user: { email: string };
  onRemove?: () => void;
}

export const WorkspaceInvite = ({ user, onRemove }: WorkspaceInviteProps) => {
  return (
    <Flex gap={39} align="center" justify="space-between">
      <Typography.Text>{user.email}</Typography.Text>
      <TrashIcon
        size={16}
        color="currentColor"
        style={{ cursor: "pointer", color: "#1F2937" }}
        className="workspace-invite-trash"
        onClick={onRemove}
      />
      <style>{`
        .workspace-invite-trash:hover {
          color: red !important;
        }
      `}</style>
    </Flex>
  );
};
